import { useRef, useState } from "react";
import CreateAdvertisementModal, {
  CreateAdvertisementModalRef,
} from "../../components/advertisement/CreateAdvertisementModal";

import styles from "./Advertisement.module.scss";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../components/common/PrimaryButton";
import {
  PrimaryButtonSize,
  PrimaryButtonType,
} from "../../components/common/PrimaryButton/PrimaryButton";
import ActionButton from "../../components/common/ActionButton/ActionButton";
import AdvertisementTable from "../../components/advertisement/AdvertisementTable";
import type { AdvertisementTableRef } from "../../components/advertisement/AdvertisementTable";
import classNames from "classnames";

const Advertisement = () => {
  const { t } = useTranslation();
  const createAlertModalRef = useRef<CreateAdvertisementModalRef>(null);
  const tableRef = useRef<AdvertisementTableRef>(null);
  const [hasPendingOrder, setHasPendingOrder] = useState(false);
  const [isSavingOrder, setIsSavingOrder] = useState(false);

  const handleOrderChange = (pending: boolean, saving: boolean) => {
    setHasPendingOrder(pending);
    setIsSavingOrder(saving);
  };

  const handleSaveOrder = () => {
    tableRef.current?.saveOrder();
  };
  return (
    <div className={classNames(styles.page_layout, styles.alerts_page)}>
      <div className={styles.alerts_container}>
        <div className={styles.header}>
          <h1>{t("lbl_advertisement")}</h1>
          <div className={styles.button_container}>
            <ActionButton
              size={PrimaryButtonSize.REGULAR}
              onClick={() => createAlertModalRef.current?.openModal()}
              backgroundColor="black">
              <p className={styles.button_text}>{t("lbl_add_alert")}</p>
            </ActionButton>
          </div>
        </div>
        <p className={styles.subtitle}>{t("lbl_promotion_management")}</p>
        <AdvertisementTable
          ref={tableRef}
          modalRef={createAlertModalRef}
          onOrderChange={handleOrderChange}
        />
        {hasPendingOrder && (
          <div className={styles.button_container}>
            <div className={styles.save_order_container}>
              <ActionButton
                size={PrimaryButtonSize.REGULAR}
                buttonType={PrimaryButtonType.PRIMARY_DARK}
                onClick={handleSaveOrder}
                disabled={isSavingOrder}>
                {isSavingOrder ? t("lbl_loading") : t("save_order")}
              </ActionButton>
            </div>
          </div>
        )}
        <CreateAdvertisementModal ref={createAlertModalRef} title="test" />
      </div>
    </div>
  );
};

export default Advertisement;
